import axios from 'api';

function objectToQueryString(obj) {
  const keyValuePairs = [];

  // Iterate through the object's properties
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty?.call(obj, key)) {
      const value = obj[key];

      // Encode both the key and value to handle special characters
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(value);

      // Push the key-value pair to the array
      keyValuePairs.push(`${encodedKey}=${encodedValue}`);
    }
  }

  // Join the key-value pairs with '&' to create the query string
  return keyValuePairs.join('&');
}
export const getFeedBackConfigData = async () => {
  return axios.get(`api/elastic/feedback_config`);
};

export const getFeedBackData = async (params, signal) => {
  return axios.get(
    `api/elastic/feedback/?page=${params.page}&page_size=${params.page_size}&feedback_priority=${params.feedback_priority}&feedback_activity_status=${params.feedback_activity_status}&feedback_assigned_agent__id__in=${params.feedback_assigned_agent}&id=${params.ids}&feedback_date__range=${params.feedback_date__range}&search=${params.search}`,
    { signal: signal }
  );
};

export const getSearchData = async (parmas, signal) => {
  return axios.get(`api/elastic/feedback/filter_feedback/?${objectToQueryString(parmas)}`, {
    signal: signal
  });
};

export const getFeedBackIdData = async (params) => {
  return axios.get(`api/elastic/feedback/${params.id}/`);
};

export const getConversationData = async (params) => {
  return axios.get(`api/feedback/comment/?feedback_id=${params.id}`);
};

export const addFeedbackData = async (params) => {
  return axios.post(`api/feedback/comment/`, params);
};

export const addFeedBackModalData = async (params) => {
  return axios.post(`api/elastic/feedback/`, params);
};

export const addFeedModalDataAudioFiles = async (params) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios.post(`api/elastic/feedback/feedback_attachment/`, params, config);
};

export const getFeedBackFilterData = async (parmas, signal) => {
  return axios.get(`api/elastic/feedback/filter_feedback/?${objectToQueryString(parmas)}`, {
    signal: signal
  });
};

export const updateFeedBackStatus = async (params) => {
  return axios.patch(`api/elastic/feedback/update_feedback_status/`, params);
};
